<template>
	<div>
		<v-snackbar class="snackbar" :color="globalSnackColor" :timeout="4000" :right="true" :top="true" :value="globalSnackDisplay">
			{{ globalSnackMessage }}
		</v-snackbar>
		<v-container class="loginScreen" fluid="true" grid-list-lg text-xs-center ml-0 mr-0>
			<v-layout row wrap>
        {{ globalApp }}
				<v-flex xs6 >
					<v-card>
						<v-card-text class="px-0">
              <center v-if="isAuto == true" style="margin-top: -25px;"><img src="../shared/assets/images/3dloader.gif"  /></center>
              <h1>Sign In</h1>
              <v-form v-if="isAuto == false" v-model="isLoginValid" class="pl-4 pr-4 pt-4 pb-4">
								
								<!-- USERNAME -->
								<v-flex lg12 v-if="!hasAccountSelect">
									<label class="blackLabel">Username:</label>
									<v-text-field autocomplete="off" v-model="loginUsername" name="username" :rules="nameRules" class="customInput" required solo></v-text-field>
								</v-flex>

								<!-- PASSWORD FIELD -->
								<v-flex lg12 v-if="!hasAccountSelect">
									<label class="blackLabel">Password:</label>

									<v-text-field
										:type="showPassword ? 'text' : 'password'"
										autocomplete="off"
										id="password"
										name="password"
										v-model="loginPassword"
										:rules="passwordRules"
										required
										solo
									></v-text-field>

									<!-- SHOW/HIDE PASSWORD TEXT BUTTON -->
									<div style="text-align:right; margin-top:-10px; margin-bottom:10px;">
										<a @click="showPassword = !showPassword" style="position:relative; top: 15px; cursor:pointer; font-size:13px; color:#3A6FF2;">
											{{ showPassword ? 'Hide Password' : 'Show Password' }}
										</a>
									</div>
								</v-flex>

								<!-- ACCOUNT SELECT -->
								<v-flex lg12>
									<p v-if="hasAccountSelect">Select the account you want to be logged in to</p>
									<v-select :items="userAccountList" v-model="loginAccount" v-if="hasAccountSelect" label="Select Account" autocomplete solo></v-select>
								</v-flex>

								<!-- BUTTONS -->
								<v-btn color="success" class="text-xs-right" @click.prevent="fncCompleteLogin" 
                  v-if="hasAccountSelect" :disabled="!loginAccount">Select</v-btn>

								<v-btn color="success loginBtn" class="text-xs-right" @click.prevent="fncAuthorizeLogin" 
                  v-if="!sendingLoginAuth && !hasAccountSelect">Login</v-btn>

								<v-progress-circular indeterminate v-if="sendingLoginAuth" 
                  :width="3" :size="20" color="grey" class="pt-3 loginLoader"></v-progress-circular>

                <v-btn v-if="!hasAccountSelect" color="success" 
                  class="text-xs-right fPassButton" @click.stop="showForgot()">Forgot Password</v-btn>

								<div class="clearfix"></div>
							</v-form>
						</v-card-text>
            <div class="versionNumber">Version: <b>Bolt</b></div>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
		<modal></modal>
	</div>
</template>

<script>

import Modal from '../shared/modal';
import { mapGetters } from 'vuex';
import router from '@/router';

export default {
	data () {
		return {
			isLoginValid: false,
			loginUsername: '',
			nameRules: [
				v => !!v || 'Username is required',
				v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email must be valid'
			],
			loginPassword: '',
			passwordRules: [
				v => !!v || 'Password is required'
			],

			// 🔥 NEW toggle for text-based show/hide
			showPassword: false,

			loginAccount: '',
      isAuto: false
		};
	},
	computed: {
		...mapGetters([
			'loginStatus',
			'sendingLoginAuth',
			'resetComplete',
			'hasAccountSelect',
			'userAccountList',
			'loginIdFinal',
			'sessionId',
			'objAuthorize',
			'jwtAuth',
			'globalSnackColor',
			'globalSnackMessage',
			'globalSnackDisplay',
			'globalModalTitle',
			'globalModalComponent',
      'globalModalState',
      'globalApp'
		])
	},
	methods: {
		fncAuthorizeLogin () {
			this.$store.dispatch({
				type: 'fncAuthorizeLogin',
				username: this.loginUsername,
				password: this.loginPassword
			});
		},
		showForgot() {
			this.$store.dispatch('fncClearLogin');
			var modalDetails = { title: 'Set New Password', component: 'modal-forgot-password', mstate: true };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},
		fncCompleteLogin () {
			this.$store.dispatch('fncSpineSetup', this.loginAccount.id);
		},
		userLogout () {
			this.$store.commit('setJwtAuthExpired');
		}
	},
	components: {
		Modal
	},
	watch: {
		resetComplete () {
			this.modalProps = {};
		}
  },
  beforeMount() {
      if( this.$route.query.t ) {

        if( this.objAuthorize.id != null && this.objAuthorize.id > 0 ) {
          router.replace('/reports/sales-order-reports?quoteno='+this.$route.query.quoteno);
        } else {
          this.$store.dispatch({
            type: 'fncAutoLogin',
            t: this.$route.query.t,
            b: this.$route.query.b,
            m: this.$route.query.m,
            quoteno: this.$route.query.quoteno
          })
        }
      } else {
        if( this.objAuthorize.id != null && this.objAuthorize.id > 0 ) {
          router.replace('/');
        }
      }
    },
    mounted() {
      this.isLoginValid = true;

      if( this.$route.query.setPass != undefined ) {
        this.showForgot();
      }

      if( this.$route.query.t ) {
        this.isAuto = true;
      } else {
        this.isAuto = false;
      }
    },
    created() {
      var vm = this;
      window.addEventListener('keyup', function (event) {
      	if( window.location.href.indexOf('login') != -1 ) {
				if (event.keyCode === 13) {
					if (vm.hasAccountSelect == false ) {
						vm.fncAuthorizeLogin();
					} else {
						vm.fncCompleteLogin();
					}
				}
			}
      })
    }
};
</script>

<style>
	@import './assets/css/auth.css'
</style>
